import React from 'react';
import { BsFilter } from '@react-icons/all-files/bs/BsFilter';
import { BsFilterLeft } from '@react-icons/all-files/bs/BsFilterLeft';
import { ButtonGroupField, Option, SelectField, TextInputField } from '@bucketplace/commerce-admin-ui';
import { LIGHT_THEME } from '@bucketplace/design-system';

import { FieldItem, FormContent } from '../../components';
import { DurationInputField } from '../../components/Duration/DurationInputField';
import { ImageField } from '../../components/Input/ImageField';
import { InspectorFormProvider } from '../../components/InspectorFormProvider';
import { DocumentInspectorProps } from '../../types';
import { convertDurationFormat } from '../../utils';
import { CountdownProps, TIMER_PREFIX_MAP } from './Countdown';

const TIMER_PREFIX_OPTIONS: Option<CountdownProps['timerPrefix']>[] = [
  { text: TIMER_PREFIX_MAP.start, value: 'start' },
  { text: TIMER_PREFIX_MAP.end, value: 'end' },
];

const TEXT_COLOR_OPTIONS: Option<CountdownProps['color']>[] = [
  { text: '블랙', value: LIGHT_THEME.base.neutral600 },
  { text: '화이트', value: LIGHT_THEME.base.neutral0 },
];

const ALIGN_OPTIONS = [
  {
    text: <BsFilterLeft />,
    value: 'left',
  },
  {
    text: <BsFilter />,
    value: 'center',
  },
];

export function CountdownInspector({
  value: inspectorValue,
  onChange,
}: DocumentInspectorProps<CountdownProps>) {
  const convertedDuration = convertDurationFormat(inspectorValue.props.duration);
  const formValue = {
    ...inspectorValue,
    props: {
      ...inspectorValue.props,
      duration: convertedDuration,
    },
  };

  return (
    <InspectorFormProvider value={formValue} onChange={onChange}>
      <FormContent
        header="노출시간 설정"
        required
        direction="VERTICAL"
      >
        <DurationInputField name="duration" />
      </FormContent>
      <FormContent header="카운트다운 설명문구" direction="VERTICAL">
        <FieldItem error hint="최대 20자까지 입력 가능합니다." hintAlign="end">
          <TextInputField
            name="subText"
            width="100%"
            maxCount={20}
          />
        </FieldItem>
      </FormContent>
      <FormContent header="타이머 앞 문구" required>
        <SelectField
          name="timerPrefix"
          width="100%"
          options={TIMER_PREFIX_OPTIONS}
        />
      </FormContent>
      <FormContent header="정렬" required>
        <ButtonGroupField
          name="align"
          width="100%"
          options={ALIGN_OPTIONS}
        />
      </FormContent>
      <FormContent header="글자색" required>
        <SelectField
          name="color"
          width="100%"
          options={TEXT_COLOR_OPTIONS}
        />
      </FormContent>
      <FormContent header="배경이미지">
        <ImageField
          name="backgroundImage"
        />
      </FormContent>
    </InspectorFormProvider>
  );
}
